export const HOMEPAGE = '/';
export const API_ROOT = 'https://cms.chainview.us';
export const PAGES_LIMIT = 9;
